import primer from "../primer"
import upsell from "../upsell"
import exitIntentPopup from "../exitIntentPopup"
import { getFirstBasicOffer } from "../helpers"
import { TrackingManager } from "../../../../../lib/common/js/services/tracking/trackingManager"

export default (getView) =>
  ({ nextStepPath, failedPaymentPath, exitIntentPath, upsellItem, secondExitIntentPath, isSingleMonthAc }) => ({
    ...getView(nextStepPath),
    ...upsell(upsellItem),
    ...primer(),
    ...exitIntentPopup(exitIntentPath, secondExitIntentPath),

    paymentMethods: [],
    offers: [],
    activeOffer: null,
    showSpinner: false,
    showFetchError: false,
    paymentError: false,
    error: null,
    statusToTrack: "VISIT_CHECKOUT",

    internalTracker: new TrackingManager(
      window.trackingConfig.enabledTrackingServices,
      pipelineConfig,
    ),

    init() {
      const searchParams = new URLSearchParams(window.location.search)
      const primerErrorSearchParam = searchParams.get("primer_error")
      const basicExitIntentOffer = pipelineConfig.offers.filter(
        (offer) => offer.type && offer.type.toLowerCase() === "basic_exit_intent",
      )

      if (primerErrorSearchParam) {
        this.error =
          primerTranslations.errors[primerErrorSearchParam] || primerTranslations.errors.default
        this.paymentError = true
      }

      this.store.trackViewAndMaybeStatus(this.statusToTrack)

      if (isSingleMonthAc) {
        const offer = getFirstBasicOffer()
        this.store.setActiveOffer(offer)
      }

      this.initExitIntentPopup()
      this.commonInit()

      const isBasicCheckout = upsellItem === "basic"

      if(this.store.values.trialExitIntent && isBasicCheckout) {
        this.activeOffer = basicExitIntentOffer[0]
        this.store.setActiveOffer(this.activeOffer)
        sessionStorage.setItem("trialExitIntent", "true")
      } else {
        this.activeOffer = this.store.values.activeOffer
      }

      // For Basic checkout
      if (isBasicCheckout) {
        this.initPrimer({
          checkoutCompletePath: nextStepPath,
          checkoutFailedPath: failedPaymentPath,
        })

        return
      }

      this.initUpsell()
      this.initPrimer({
        checkoutCompletePath: this.getThankYouPath(),
        checkoutFailedPath: this.getFailedCheckoutPath(),
      })
    },

    // CF d-series code

    async backButtonHandler() {
      const { values } = this.store

      this.internalTracker.trackClick({ clickName: "Back Clicked" })

      if (this.store.shouldShowExitIntentPopup()) {
        const token = values.token
        const tokenPath = token ? `${exitIntentPath}#stored-token=${token}` : popupStepPath

        window.location.replace(tokenPath)
      } else {
        if (this.store.isFFPipeline() && values.exitIntent) {
          const ffOrigin = values.ffOrigin
          const ffOriginPath = values.ffOriginPath
          const ffExitIntentPath = values.ffExitIntentPath
          const ffSessionId = values.ffSessionId

          if (ffOrigin && ffExitIntentPath) {
            window.location.replace(
              `${ffOrigin}/${ffOriginPath}/${ffExitIntentPath}/?fsid=${ffSessionId}`,
            )
            return
          } else {
            throw new Error("[FF] Missing ff origin or ff exit intent path")
          }
        }

        history.back()
      }
    },

    getDiscountKey(isTrialOffer, isExitIntent) {
      if (isTrialOffer && isExitIntent) return "trial_exit_intent_price_discount"
      if (isTrialOffer) return "trial_price_discount"
      if (isExitIntent) return "exit_intent_discount"

      return "discount"
    },

    getFormattedDiscountPercentage() {
      const { exitIntent } = this.store.values
      const isTrialOffer = this.store.isOfferTrial(this.activeOffer)
      const isBasicOffer = this.store.isBasicOffer(this.activeOffer)
      const discountKey = this.getDiscountKey(isTrialOffer, exitIntent)

      if (!isBasicOffer) {
        return this.activeOffer.customData.discount || null
      }

      return this.activeOffer.customData[discountKey]
    },

    getFormattedDiscount() {
      const { exitIntent } = this.store.values
      const isTrial = this.store.isOfferTrial(this.activeOffer)
      const isBasicOffer = this.store.isBasicOffer(this.activeOffer)
      const {
        exit_intent_discount_amount = 0,
        trial_price_discount_amount = 0,
        trial_exit_intent_price_discount_amount = 0,
        total_price_discount = 0,
      } = this.activeOffer.customData

      if (!isBasicOffer) return this.store.getFormattedPrice(total_price_discount)
      if (isTrial && exitIntent)
        return this.store.getFormattedPrice(trial_exit_intent_price_discount_amount)
      if (isTrial) return this.store.getFormattedPrice(trial_price_discount_amount)
      if (exitIntent) return this.store.getFormattedPrice(exit_intent_discount_amount)

      return this.store.getFormattedPrice(total_price_discount)
    },

    isNutritionistBubbleNeeded(upsellItem) {
      const bubbleNeededKeys = ["premium", "chat", "shopping_list", "shopping_list_and_premium", "workouts"]

      return bubbleNeededKeys.includes(upsellItem)
    },

    scrollToPrimer() {
      document
        .getElementById("primer")
        .scrollIntoView({ behavior: "smooth", block: "start", inline: "center" })
    },

    getStandardPrice() {
      return this.store.getFormattedPrice(this.activeOffer.customData.total_price)
    },
  })
